document.querySelectorAll('.quick-add__submit').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default form submission behavior

    // Get the form element associated with the button
    const form = this.closest('form');

    if (form) {
      // Submit the form via AJAX
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form)
      })
      .then(response => response.json())
      .then(data => {
        // Manually trigger Shopify's cart:updated event
        const cartUpdatedEvent = new CustomEvent('cart:updated', { detail: data });
        document.dispatchEvent(cartUpdatedEvent);

        // Check if Qikify's upsell function exists, and trigger it
        if (typeof qikifyPopup !== 'undefined' && typeof qikifyPopup.show === 'function') {
          qikifyPopup.show();
        }

        // Optionally, update cart UI if needed
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  });
});
